import { Injectable } from '@angular/core';
import { isSafeInternalUrl } from '../../shared/utils';

const STORAGE_KEY = 'oauth_return_url';

/**
 * Return address for the third-party datasource OAuth round trip
 * (`credentialsGuard` -> the provider's consent screen -> `/auth/oauth-callback`).
 *
 * This is a different flow from the SSO login and gets its own key. Sharing
 * `post_login_redirect` meant the two overwrote each other, and
 * `oauth-callback` read the value without clearing it, so a stale target
 * survived into later navigations.
 */
@Injectable()
export class OAuthReturnService {
  remember(url: string): void {
    if (!isSafeInternalUrl(url)) {
      return;
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, url);
    } catch {
      // Storage disabled: the fallback target is good enough.
    }
  }

  /** Reads and clears the remembered URL. Returns null when there is none. */
  consume(): string | null {
    try {
      const url = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);

      return isSafeInternalUrl(url) ? url : null;
    } catch {
      return null;
    }
  }
}
